import {
  useEffect,
  useState,
  type AnchorHTMLAttributes,
  type ReactNode,
} from "react";
import Link from "next/link";
import { appendAttributionBridgeParams } from "@/lib/dashboard-urls";

type AttributionHrefLinkProps = {
  href: string;
  children: ReactNode;
  className?: string;
  /** Use next/link (default) or a plain <a> for external targets. */
  external?: boolean;
} & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href" | "children" | "className">;

/**
 * Link that rewrites dashboard signup URLs and appends attribution bridge
 * params after mount (SSR-safe fallback without params).
 */
export function AttributionHrefLink({
  href,
  children,
  className,
  external = false,
  ...rest
}: AttributionHrefLinkProps) {
  const [currentHref, setCurrentHref] = useState(href || "/");

  useEffect(() => {
    if (!href) {
      setCurrentHref("/");
      return;
    }
    setCurrentHref(appendAttributionBridgeParams(href));
  }, [href]);

  if (external) {
    return (
      <a href={currentHref} className={className} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <Link href={currentHref} className={className} prefetch={false} {...rest}>
      {children}
    </Link>
  );
}
